import sha256 from 'js-sha256'

let baseUrl = 'https://hello-get.com'
let secret = 'NOPjVeOWAzZLoAjk'

/**
 * 显示 mm：ss 格式的时间
 * @param int seconds
 * @return string format: 00 : 00
 */
let formatSeconds = seconds => {
    var second = parseInt(seconds);// 秒
    var minute = 0;// 分
    if (second >= 60) {
      minute = parseInt(second / 60);
      if(minute < 10){
          minute = "0" + minute;
      }
      second = parseInt(second % 60);
      if(second<10){
          second = "0" + second;
      }
      return minute + " : " + second;
    } else {
      second = parseInt(second % 60);
      if(second<10){
          second = "0" + second;
      }
      return "00 : " + second;
    }
}

// sh256(ts+tts+app_seceret);
let createToken = () => {
    var ts = Date.parse(new Date())/1000
    var tts = ts * 3 +1
    var tsStr = ts.toString()
    var ttsStr = tts.toString()
    var token = sha256(tsStr + ttsStr + secret)
    return token
}

export default {
    baseUrl: baseUrl,
    formatSeconds: formatSeconds,
    createToken: createToken
}



// WEBPACK FOOTER //
// ./src/utils/utils.js